import React, { useState, useEffect } from 'react'
import { getFirestore, collection, query, getDocs } from "@firebase/firestore"
import { app } from '../../firebase.js'
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts'
import Table from 'react-bootstrap/Table'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'

function SessionTimeDemand() {
  const db = getFirestore(app)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, 'users'))
      const qs = await getDocs(q)

      const counts = {}

      qs.forEach(doc => {
        const d = doc.data()
        const session = d.sessionTime && d.sessionTime.trim() ? d.sessionTime : 'Unspecified'
        counts[session] = (counts[session] || 0) + 1
      })

      const formatted = Object.keys(counts).map(key => ({
        sessionTime: key,
        count: counts[key]
      }))

      // sort descending by count, keep top 8
      const sorted = formatted.sort((a, b) => b.count - a.count)
      const top = sorted.slice(0, 8)

      setData(top)
      setLoading(false)
    }

    fetchData()
  }, [db])

  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <div className="container mt-4">
          <h4>Session Time Demand</h4>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <h5 className="mt-3 mb-2">Top 8 Session Times</h5>

              <div style={{ width: '100%', height: 360 }}>
                <ResponsiveContainer>
                  <BarChart data={data} margin={{ top: 20, right: 20, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="sessionTime" interval={0} angle={-20} textAnchor="end" height={70} />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="count" fill="#4a90e2" name="Users" />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              <h5 className="mt-4 mb-2">Session Time Table</h5>
              <Table striped bordered hover className="mt-2">
                <thead>
                  <tr>
                    <th>Session Time</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.sessionTime}</td>
                      <td>{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default SessionTimeDemand